import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import { Link } from "@tanstack/react-router";
import LanguageSwitcher from "../../../components/LanguageSwitcher";

export default function Header(): React.JSX.Element {
  return (
    <AppBar position="static">
      <Container
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          height: "56px",
        }}
      >
        <Link
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "6px",
            marginBottom: "6px",
          }}
          to="/login"
        >
          <img
            alt="smartdocs"
            src="/assets/smartdocs-branco.png"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "80px",
            }}
            width="100%"
          />
        </Link>
        <Link
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "6px",
            marginBottom: "6px",
            flexDirection: "row",
            justifyContent: "center",
            textDecoration: "none",
            gap: 1,
          }}
          to="/login"
        >
          <img
            alt="logo"
            src="/assets/logo.png"
            style={{
              width: "100%",
              height: "auto",
              maxWidth: "90px",
            }}
            width="100%"
          />
        </Link>
        <LanguageSwitcher />
      </Container>
    </AppBar>
  );
}
